import { Component, computed, inject, input } from '@angular/core';
import { ParseRequestCreateStepCard } from '../parse-request-create-step-card/parse-request-create-step-card';
import { NgIcon } from '@ng-icons/core';
import { Badge, Button, TooltipDirective } from 'excellence-ui';
import { ParseRequestState } from '../../stores/parse-requests.store';
import { environment } from '../../../../../environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';

@Component({
  selector: 'app-parse-request-create-accordion',
  imports: [
    ParseRequestCreateStepCard,
    NgIcon,
    Badge,
    Button,
    TranslocoPipe,
    RouterLink,
    TooltipDirective,
    FeatureEnabledDirective,
  ],
  templateUrl: './parse-request-create-accordion.html',
})
export class ParseRequestCreateAccordion {
  protected activatedRoute = inject(ActivatedRoute);

  state = input.required<ParseRequestState | null>();

  activeStep = input.required<'GENERAL' | 'DOCUMENTS' | 'SUMMARY'>();

  protected generalInfoButtonLink = computed(
    () => environment.articles.parseRequest.generalInfoButton,
  );
  protected uploadDocumentsInfoButtonLink = computed(
    () => environment.articles.parseRequest.uploadDocumentsInfoButton,
  );
  protected summaryInfoButtonLink = computed(
    () => environment.articles.parseRequest.summaryInfoButton,
  );
}
